/**
 * VideoTab - Video demo section editing
 */
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';

export function VideoTab({ content, setContent }) {
  const updateVideo = (field, value) => {
    setContent(prev => ({ ...prev, video: { ...prev.video, [field]: value } }));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Video Demo Section</CardTitle>
        <CardDescription>Add a product walkthrough video</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <Label>Enable Video Section</Label>
            <p className="text-sm text-gray-500">Show video demo on landing page</p>
          </div>
          <Switch checked={content.video?.enabled || false} onCheckedChange={(checked) => updateVideo('enabled', checked)} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div><Label>Badge Text</Label><Input value={content.video?.badge || ''} onChange={(e) => updateVideo('badge', e.target.value)} placeholder="e.g., PRODUCT DEMO" /></div>
          <div><Label>Title</Label><Input value={content.video?.title || ''} onChange={(e) => updateVideo('title', e.target.value)} placeholder="e.g., See It In Action" /></div>
        </div>
        <div><Label>Subtitle</Label><Input value={content.video?.subtitle || ''} onChange={(e) => updateVideo('subtitle', e.target.value)} placeholder="Description text..." /></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>YouTube Video ID</Label>
            <Input value={content.video?.youtubeId || ''} onChange={(e) => updateVideo('youtubeId', e.target.value)} placeholder="e.g., dQw4w9WgXcQ" />
            <p className="text-xs text-gray-500 mt-1">The ID from youtube.com/watch?v=VIDEO_ID</p>
          </div>
          <div>
            <Label>Vimeo Video ID</Label>
            <Input value={content.video?.vimeoId || ''} onChange={(e) => updateVideo('vimeoId', e.target.value)} placeholder="e.g., 123456789" />
            <p className="text-xs text-gray-500 mt-1">Alternative to YouTube</p>
          </div>
        </div>
        <div><Label>Caption (optional)</Label><Input value={content.video?.caption || ''} onChange={(e) => updateVideo('caption', e.target.value)} placeholder="Text below the video..." /></div>
        {(content.video?.youtubeId || content.video?.vimeoId) && (
          <div className="bg-gray-50 rounded-lg p-4">
            <Label className="mb-2 block">Preview</Label>
            <div className="aspect-video rounded-lg overflow-hidden">
              {content.video?.youtubeId ? (
                <iframe src={`https://www.youtube.com/embed/${content.video.youtubeId}`} className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="YouTube Preview" />
              ) : content.video?.vimeoId ? (
                <iframe src={`https://player.vimeo.com/video/${content.video.vimeoId}`} className="w-full h-full" allow="autoplay; fullscreen; picture-in-picture" title="Vimeo Preview" />
              ) : null}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
